import _defineProperty from '../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import * as PropTypes from 'prop-types';
import React__default from 'react';
import clsx from 'clsx';
import { Container } from '@material-ui/core';

var useStyles = makeStyles(function (theme) {
  return {
    centerContainer: _defineProperty({
      margin: "0 auto",
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3)
    }, theme.breakpoints.up("sm"), {
      paddingRight: theme.spacing(0),
      paddingLeft: theme.spacing(0)
    }),
    loading: {
      width: "100%",
      marginTop: "10%",
      textAlign: "center"
    },
    mobile: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  };
});
var CenterContainer = function CenterContainer(_ref) {
  var maxWidth = _ref.maxWidth,
    loading = _ref.loading,
    className = _ref.className,
    children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Container, {
    style: {
      "maxWidth": maxWidth
    },
    className: clsx(className, classes.centerContainer)
  }, children && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loading ? /*#__PURE__*/React__default.createElement("div", {
    className: classes.loading
  }, /*#__PURE__*/React__default.createElement(CircularProgress, {
    size: 80
  })) : children));
};
CenterContainer.defaultProps = {
  maxWidth: 625,
  loading: false
};
CenterContainer.propTypes = {
  maxWidth: PropTypes.number,
  loading: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string
};

export { CenterContainer as default };
//# sourceMappingURL=CenterContainer.js.map
